import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import GoogleMapReact from 'google-map-react';
import {
    IconButton,
    Tooltip
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Place } from '@material-ui/icons';

// Setup the cs
// critical -> less critical
// comm - red
// batt - red
// critical level - red
// high level - yellow
// low level - yellow
// OK - green
const useStyles = makeStyles((theme) => ({
    ok: {
        color: theme.palette.success.main,
        zIndex: 1
    },
    low: {
        color: theme.palette.warning.main,
        zIndex: 2
    },
    high: {
        color: theme.palette.warning.main,
        zIndex: 3
    },
    crit: {
        color: theme.palette.error.main,
        zIndex: 4
    },
    batt: {
        color: theme.palette.error.dark,
        zIndex: 5
    },
    comm: {
        color: theme.palette.error.dark,
        zIndex: 6
    },
    error: {
        color: theme.palette.error.dark,
        zIndex: 8
    },
    none: {
        color: theme.palette.error.none,
        zIndex: 7
    },
    marker: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
}));

// Grid markers
const Marker = ({ org, branch, site, status }) => {
    const classes = useStyles();
    var status_disp = "OK";
    if ((typeof status) !== "string") {
        status_disp = "None";
    }
    else if (status.includes("Comm")) {
        status_disp = "Comm";
    }
    else if (status.includes("Batt")) {
        status_disp = "Batt";
    }
    else if (status.includes("Crit")) {
        status_disp = "Crit";
    }
    else if (status.includes("High")) {
        status_disp = "High";
    }
    else if (status.includes("Low")) {
        status_disp = "Low";
    }
    return (
        <Tooltip className={classes.marker} title={site}>
            <IconButton
                component={RouterLink}
                to={`/orgs/'${org}/branches/${branch}/sites/${site}`}
            >
                <Place className={status_disp === 'OK'
                    ? classes.ok
                    : status_disp === 'Low'
                        ? classes.low
                        : status_disp === 'High'
                            ? classes.low
                            : status_disp === 'Crit'
                                ? classes.crit
                                : status_disp === 'Comm'
                                    ? classes.comm
                                    : status_disp === 'Batt'
                                        ? classes.batt
                                        : classes.none} />
            </IconButton>
        </Tooltip>
    );
}

// Set options for the Google map
const getMapOptions = (maps) => {
    return {
        mapTypeControl: false,
        streetViewControl: false,
    };
};

export const GoogleMap = ({center, pins, org, branch}) => {
    const setGoogleMapRef = (map, maps) => {
        if (pins.length === 1) {
            map.setCenter({lat: pins[0].latitude, lng: pins[0].longitude});
            return;
        }
        const bounds = new maps.LatLngBounds();
        const formattedPins = pins.map(({latitude, longitude}) => ({lat: latitude, lng: longitude}))
        for (let i = 0; i < formattedPins.length; i++) {
            bounds.extend(formattedPins[i]);
        }

        map.setCenter(bounds.getCenter());
        map.fitBounds(bounds);
    };

    return (
        <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyDZxhyTnVftkwNDwT2dR8ygpsztsBBwrxs' }}
            defaultZoom={10}
            center={center}
            options={getMapOptions}
            onGoogleApiLoaded={({ map, maps }) => setGoogleMapRef(map, maps)}
        >
            {pins?.map((pin, index) =>
                <Marker
                    key={index}
                    org={org}
                    branch={branch}
                    site={pin['SiteName']}
                    lat={pin['latitude']}
                    lng={pin['longitude']}
                    status={pin['Status']}
                />
            )}
        </GoogleMapReact>
    );
};
